import Layout from '@/views/layout/Layout'
const userCenterRouter = {
    path: '/userCenter',
    name: 'userCenter',
    component: Layout,
    redirect: 'noRedirect',
    children: [
        // 已发布供应信息路由
        {
            path: 'logsupplyList',
            name: 'logsupplyList',
            component: () => import('@/views/userCenter/logsupplyList'),
        },
        // 发布供应信息路由
        {
            path: 'logsupplyAdd',
            name: 'logsupplyAdd',
            component: () => import('@/views/userCenter/logsupplyAdd'),
        },
        // 发布采购信息路由
        {
            path: 'logsupplyAddBuy',
            name: 'logsupplyAddBuy',
            component: () => import('@/views/userCenter/logsupplyAddBuy'),
        },
        // 订单管理路由
        {
            path: 'logorderManage',
            name: 'logorderManage',
            component: () => import('@/views/userCenter/logorderManage'),
        },
        // 订单管理路由---卖家
        {
            path: 'logorderManageSell',
            name: 'logorderManageSell',
            component: () => import('@/views/userCenter/logorderManageSell'),
        },
        // 订单管理路由---会员订单
        {
            path: 'logorderVip',
            name: 'logorderVip',
            component: () => import('@/views/userCenter/vip/logorderVip'),
        },
        // 发票管理路由--我的发票
        {
            path: 'logmyInvoice',
            name: 'logmyInvoice',
            component: () => import('@/views/userCenter/logmyInvoice'),
        },
        // 发票管理路由--发票信息
        {
            path: 'loginvoiceInfo',
            name: 'loginvoiceInfo',
            component: () => import('@/views/userCenter/loginvoiceInfo'),
        },
        // T币管理路由
        {
            path: 'logtbManage',
            name: 'logtbManage',
            component: () => import('@/views/userCenter/logtbManage'),
        },
        // T币列表路由
        {
            path: 'logtbList',
            name: 'logtbList',
            component: () => import('@/views/userCenter/logtbList'),
        },
        // 信息管理路由
        {
            path: 'loginfoManage',
            name: 'loginfoManage',
            component: () => import('@/views/userCenter/loginfoManage'),
        },
        // 信息管理路由--信息详情
        {
            path: 'loginfoManageDetail',
            name: 'loginfoManageDetail',
            component: () => import('@/views/userCenter/loginfoManageDetail'),
        },
        // 我的收藏路由
        {
            path: 'logmyStar',
            name: 'logmyStar',
            component: () => import('@/views/userCenter/logmyStar'),
        },
        // 购物车路由
        {
            path: 'logcar',
            name: 'logcar',
            component: () => import('@/views/userCenter/logcar'),
        },
        // 会员选择
        {
            path: 'logvipSelect',
            name: 'logvipSelect',
            component: () => import('@/views/userCenter/vip/logvipSelect'),
        },
        // 会员服务路由
        {
            path: 'logvipServices',
            name: 'logvipServices',
            component: () => import('@/views/userCenter/vip/logvipServices'),
        },
        // 企业信息路由
        {
            path: 'logcompanyInfo',
            name: 'logcompanyInfo',
            component: () => import('@/views/userCenter/logcompanyInfo'),
        },
        // 企业信息路由--联系方式
        // {
        //     path: 'logcompanyInfoTel',
        //     name: 'logcompanyInfoTel',
        //     component: () => import('@/views/userCenter/logcompanyInfo'),
        // },
        // 账号信息路由
        {
            path: 'loguserInfo',
            name: 'loguserInfo',
            component: () => import('@/views/userCenter/loguserInfo'),
        },
        // 收货地址路由
        {
            path: 'logaddress',
            name: 'logaddress',
            component: () => import('@/views/userCenter/logaddress'),
        },
        // 选择企业会员路由
        {
            path: 'logvipServicesSelectvip',
            name: 'logvipServicesSelectvip',
            component: () => import('@/views/userCenter/vip/logvipServicesSelectvip'),
        },
        // 选择设计师会员路由
        {
            path: 'logvipServicesSelectdesigner',
            name: 'logvipServicesSelectdesigner',
            component: () => import('@/views/userCenter/vip/logvipServicesSelectdesigner'),
        },
        // 选择账号路由
        {
            path: 'logvipServicesSelectuser',
            name: 'logvipServicesSelectuser',
            component: () => import('@/views/userCenter/vip/logvipServicesSelectuser'),
        },
        // 组合套餐路由
        {
            path: 'logvipServicesTaocan',
            name: 'logvipServicesTaocan',
            component: () => import('@/views/userCenter/vip/logvipServicesTaocan'),
        },
        // 会员服务付款路由
        {
            path: 'logvipServicesPay',
            name: 'logvipServicesPay',
            component: () => import('@/views/userCenter/vip/logvipServicesPay'),
        },
        // 设计师管理路由--发布内容
        {
            path: 'logdesignerManage',
            name: 'logdesignerManage',
            component: () => import('@/views/userCenter/logdesignerManage'),
        },
        // 设计师管理路由--我的作品
        {
            path: 'logdesignerProduct',
            name: 'logdesignerProduct',
            component: () => import('@/views/userCenter/logdesignerManage'),
        },
        // 设计师作品详情路由
        {
            path: 'logdesignerworks',
            name: 'logdesignerworks',
            component: () => import('@/views/userCenter/logdesignerworks'),
        },
        // 一物一码列表路由
        {
            path: 'logwechatCode',
            name: 'logwechatCode',
            component: () => import('@/views/userCenter/logwechatCode'),
        },
        // 一物一码列表去购买二维码路由
        {
            path: 'logwechatCodeBuy',
            name: 'logwechatCodeBuy',
            component: () => import('@/views/userCenter/logwechatCodeBuy'),
        },
        // 发布供应--产品编号设置路由
        {
            path: 'logsupplyPrefix',
            name: 'logsupplyPrefix',
            component: () => import('@/views/userCenter/logsupplyPrefix'),
        },
    ]
}
export default userCenterRouter


// WEBPACK FOOTER //
// ./src/router/modules/userCenter.js